import {z} from 'zod';

export const Dealer = z.object({
  name: z.string(),
  street: z.string(),
  postalCode: z.string(),
  city: z.string(),
  telephoneNumber: z.string(),
  faxNumber: z.string(),
});

export type Dealer = z.infer<typeof Dealer>;
